var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuttingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5231 0.0541553C17.4542 0.0842686 17.351 0.1574 17.3037 0.213326C17.2219 0.303667 14.7698 4.20121 14.5031 4.66151C14.4515 4.75616 14.4042 4.89812 14.4042 4.97986C14.4042 5.10031 13.5266 6.60168 9.99039 12.5383L5.57661 19.9462L5.44325 19.929C4.84959 19.8516 1.19726 19.5634 0.960652 19.5763C0.465931 19.6107 0.164797 19.8215 0.0357391 20.2302C-0.0761109 20.5829 0.091664 21.5207 0.302458 21.7186C0.354081 21.766 0.465931 21.8219 0.55197 21.8434C0.633706 21.8649 1.80813 21.9165 3.15463 21.9552C5.86054 22.0327 6.10145 22.0241 6.52734 21.8133C7.03497 21.5638 7.08659 21.2024 6.70802 20.613L6.54455 20.3592L10.9024 13.0546C14.787 6.53715 15.2774 5.737 15.4237 5.65096C15.5614 5.56492 15.798 5.21646 16.9896 3.2978C17.764 2.06315 18.4179 1.00058 18.448 0.944653C18.5211 0.802689 18.4781 0.445629 18.3748 0.303667C18.1726 0.0326462 17.8027 -0.0749035 17.5231 0.0541553Z",
    fill: "#787486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuttingIcon);
export default __webpack_public_path__ + "static/media/putting-icon.94665032dddaedae9c682451b7281a9e.svg";
export { ForwardRef as ReactComponent };